import React from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import {
  NOTIFICATION_LEVEL_ERROR,
} from '@avtechsoftware/ra-javascript-utilities/src/types/NotificationLevels';
import {
  selectSingleAlert,
  setSingleAlertIsFavorite,
} from '../../../redux/slices/singleAlertSlice/singleAlertSlice';
import {
  pushSessionMessage,
} from '../../../redux/slices/toastNotificationSlice/toastNotificationSlice';

const useFavoriteSingleAlert = () => {
  const alert = useSelector(selectSingleAlert);
  const debounce = React.useRef(false);
  const dispatch = useDispatch();

  const toggleFavoriteAlert = (alertId) => {
    if (!debounce.current) {
      debounce.current = true;
      const params = new URLSearchParams();
      params.append('alertId', alertId);
      const fallback = alert.isFavorite;
      dispatch(setSingleAlertIsFavorite({ isFavorite: !alert.isFavorite }));
      axios.post('/alerts/data/toggle-alert-favorite-status', params)
        .catch(() => {
          dispatch(setSingleAlertIsFavorite({ isFavorite: fallback }));
          dispatch(pushSessionMessage({
            level: NOTIFICATION_LEVEL_ERROR,
            title: 'Unexpected error',
            body: 'Unexpected error updating alert favorite.',
          }));
        })
        .finally(() => {
          debounce.current = false;
        });
    }
  };

  return {
    toggleFavoriteAlert,
  };
};

export default useFavoriteSingleAlert;
